export const hprScoreKeys = {
  worstTissueTypeScore: "worstTissueTypeScore",
  surfaceAreaValueScore: "surfaceAreaValueScore",
  intactValueScore: "intactValueScore",
  hprScore: "hprScore"
};
